<script setup lang="ts">
definePageMeta({
  alias: ['/pedidos/checkout', '/commandes/checkout'],
  pageType: 'CHECKOUT',
})

const appStore = useAppStore()

useHeadSafe({
  meta: [
    {
      name: 'robots',
      content: 'noindex, nofollow',
    },
  ],
})
</script>

<template>
  <Loader v-if="!appStore.initialFetchLoaded" fit />
  <CheckoutView v-else />
</template>
